module.exports = __webpack_public_path__ + "media/images/top/yuge-252c5f009170f8ccc1cb60375053ae8d.webp";